export default __webpack_public_path__ + "static/media/other.506ac2a1.svg";